import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { LifestyleUUID } from '../../../lifestylesTypes';

import {
  FETCH_LIFESTYLE_DOWNLOAD_URLS_QUERY,
  FetchLifestyleDownloadUrlsQueryResponse
} from '../../../queries/fetchLifestyleDownloadUrls.query';

import { useShowLifestyle } from '../../../hooks/useShowLifestyle';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { LifestyleCache } from '../../../LifestyleCache';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

interface DownloadLifestyleSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  lifestyleUuid: LifestyleUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadLifestyleSeparatelyButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  lifestyleUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadLifestyleSeparatelyButtonProps & GADataType) {
  const { lifestyleLoading, refetchLifestyle, lifestyleError } =
    useShowLifestyle<FetchLifestyleDownloadUrlsQueryResponse>({
      cacheKey: LifestyleCache.downloadUrls(lifestyleUuid),
      options: {
        enabled: false,
        enabledPlaceholder: false
      },
      query: FETCH_LIFESTYLE_DOWNLOAD_URLS_QUERY,
      uuid: lifestyleUuid
    });

  useShowToastOnErrorChange({ error: lifestyleError });

  return (
    <DownloadUrlsModalButton<'lifestyle'>
      className={className}
      dataGa={dataGa}
      disabled={lifestyleLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      refetchItemDownloadUrls={refetchLifestyle}
      scope="lifestyle"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadLifestyleSeparatelyButton;
